import { useAppDispatch, useAppSelector } from "app/hooks";
import { setOpenPanel } from "features/settings/details-slice";
import { useCallback, useEffect, useState } from "react";
import Panel from "shared/components/Panel";
// import DatePicker from "react-datepicker";
import { notNullNorUndefined } from "shared/helpers/notNullNorUndefined";
import { eachDayOfInterval, interval, isSameDay } from "date-fns";
import { DateOption, dateIconClass } from "./components/DateOption";
import { CalendarProps } from "react-calendar";
import { DateSelector } from "./components/DateSelector";
import Spinner from "shared/components/Spinner";
// import useMedia from "use-media";
// import { MOBILE_VIEW_BREAKPOINT } from "shared/helpers/mediaQueries";

const FAKE_DATA: Pick<
  Parameters<typeof DateOption>[0],
  "date" | "scoutPhotoAvailable" | "spherePhotoAvailable"
>[] = eachDayOfInterval(
  interval(
    new Date().valueOf() - 1000 * 60 * 60 * 24 * 7,
    new Date().valueOf() + 1000 * 60 * 60 * 24 * 1
  )
).map((date, index) => ({
  date: date,
  spherePhotoAvailable: index % 2 === 0,
  scoutPhotoAvailable: index % 3 === 0,
}));

interface PanelSphereSelectorProps {}

const PanelSphereSelector: React.FC<PanelSphereSelectorProps> = () => {
  // const largerThanMobileView = useMedia(MOBILE_VIEW_BREAKPOINT);
  // Redux state
  const showPanel = useAppSelector(
    (state) => state.settings.openPanel === "sphereSelector"
  );
  const guid = useAppSelector((state) => state.panorama.guid);

  // Panel state
  const dispatch = useAppDispatch();
  const closePanel = useCallback(() => {
    setDatePickerOpen(false);
    dispatch(setOpenPanel(null));
  }, [dispatch]);

  // NOTE: This will likely move to Redux
  // Some data will be used to tell krpano what to show in the compare feature
  const [compareDate, setCompareDate] = useState<Date | undefined>(undefined);

  // Date Picker State
  const [datePickerOpen, setDatePickerOpen] = useState<boolean>(false);
  const [datePickerDate, setDatePickerDate] = useState<CalendarProps["value"]>(
    new Date()
  );
  const [loading, setLoading] = useState<boolean>(false);
  const onChange = useCallback((date: CalendarProps["value"]) => {
    setDatePickerDate(date);
    setDatePickerOpen(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    // NOTE: This will be the hook to get the array of new items
    // The result of which will replace `FAKE_DATA`
    // console.log("DatePicker Date", datePickerDate);
    setLoading(false);
  }, [datePickerDate]);

  // TODO: Call `setDatePickerOpen(false);` when clicking inside the panel
  // useOnClickOutside might be useful here

  return (
    <Panel
      showPanel={showPanel}
      direction="bottom"
      headerBorder="BorderBottom"
      closePanel={closePanel}
      underlayClass="NoUnderlay"
      // panelSize={largerThanMobileView ? "normal" : "full"}
      scrollClass="ScrollAllInner"
      withBorderRadius
      // scrollClass="ScrollContent"
      headerElement={
        <h2 className="h2Small">Select from available Sphere Dates</h2>
      }
    >
      {guid ? (
        <div className="PanelSphereSelector">
          <div className="DatePickerParent DisplayFlex SpaceBetween">
            {/* Left */}
            <DateSelector
              date={datePickerDate}
              open={datePickerOpen}
              setOpen={setDatePickerOpen}
              onChange={onChange}
            />
            {/* Right */}
            <div className="DisplayFlex LargeGap">
              <div className="DisplayFlex AlignCentre VSmallGap">
                <div className={dateIconClass("SpherePhoto", true)} />
                <span>Sphere photo available</span>
              </div>
              <div className="DisplayFlex AlignCentre VSmallGap">
                <div className={dateIconClass("ScoutPhoto", true)} />
                <span>Scout photo available</span>
              </div>
            </div>
          </div>
          <div className="DateOptions DisplayFlex JustifyCentre">
            {FAKE_DATA.map(
              ({ date, spherePhotoAvailable, scoutPhotoAvailable }, index) => (
                <DateOption
                  key={`DATE_OPTION_${index}${date.valueOf()}`}
                  date={date}
                  isSelected={
                    notNullNorUndefined(compareDate) &&
                    isSameDay(date, compareDate)
                  }
                  spherePhotoAvailable={spherePhotoAvailable}
                  scoutPhotoAvailable={scoutPhotoAvailable}
                  onClick={(selectedDate) => {
                    setCompareDate(selectedDate);
                  }}
                />
              )
            )}
          </div>
        </div>
      ) : (
        <>An unknown error occurred! Please try again later.</>
      )}
      <Spinner show={loading} underlayClass="FaintUnderlay" />
    </Panel>
  );
};

export default PanelSphereSelector;
